/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { connectMenu } from 'instantsearch.js/es/connectors';
import { searchBox, pagination } from 'instantsearch.js/es/widgets';
import customHits from './widgets/hits-post';

const DOM = {
    searchForm: document.querySelector('.js-post-search-form'),
};

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}post`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/blog/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;
                    const queryParameters = {};

                    // query
                    if (routeState.query) {
                        queryParameters.query = encodeURIComponent(routeState.query);
                    }

                    // page
                    if (routeState.batch !== 1) {
                        queryParameters.batch = routeState.batch;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}blog/${queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const {
                        query = '',
                        batch,
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        query: decodeURIComponent(query),
                        batch,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_post || {};

                    return {
                        query: indexUiState.query,
                        batch: indexUiState.page,
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_post: {
                            query: routeState.query,
                            page: routeState.batch,
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            const page = helper.getPage() || 0;

            helper
                .toggleFacetRefinement('visibility', 'visible')
                .setPage(page);

            helper.search();
        },
    });

    const virtualMenu = connectMenu(() => null);

    search.addWidgets([
        searchBox({
            container: DOM.searchForm,
            placeholder: 'Search posts',
        }),

        virtualMenu({
            attribute: 'visibility',
        }),

        customHits({
            container: document.querySelector('.js-post-search-results'),
        }),

        pagination({
            container: document.querySelector('.js-post-search-pagination'),
        }),
    ]);

    search.start();
};

const init = () => {
    if (!DOM.searchForm) return;
    setup();
};

export default init;
